import React from 'react';
import { LAYOUT } from '../../styles/constants';
import useMediaQuery from '../../hooks/useMediaQuery';
import { Square, Download } from 'lucide-react';

interface SidebarCardProps {
  title: string;
  items: string[];
  type: 'notice' | 'downloads';
}

const SidebarCard = ({ title, items, type }: SidebarCardProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const cardWidth = isDesktop ? LAYOUT.WELCOME.SIDEBAR_CARD.WIDTH : `${LAYOUT.WELCOME.SIDEBAR_CARD.WIDTH / 2}px`;

  return (
    <div 
      className="bg-[#D9D9D9] p-6 relative"
      style={{ 
        width: cardWidth,
        height: LAYOUT.WELCOME.SIDEBAR_CARD.HEIGHT
      }}
    >
      <h3 className="font-bold text-lg mb-4">{title}</h3>
      <div className="absolute left-0 right-0" style={{ height: '4.2px', backgroundColor: '#843131', width: '98.4px' }} />
      <ul className="space-y-3 mt-6">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {type === 'notice' ? (
              <Square size={16} className="flex-shrink-0" />
            ) : (
              <Download size={16} className="flex-shrink-0" />
            )}
            <span className="text-sm">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarCard;